import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Redirect, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Loader from 'App/components/Loader'
import CallbackPage from '../../common/pages/oidc/callbackPage'
import Logout from '../../common/pages/logout'
import { TDefaultSagas } from 'App/redux/interface'

import AppLayout from './App'
import AuthLayout from 'App/layouts/Auth'
import PublicLayout from 'App/layouts/Public'

import 'antd/lib/layout/style'

enum ELayoutTypes {
  public = 'public',
  auth = 'auth',
  app = 'app',
}

const Layouts = {
  [ELayoutTypes.public]: PublicLayout,
  [ELayoutTypes.auth]: AuthLayout,
  [ELayoutTypes.app]: AppLayout,
}

type TApplicationLayoutProps = {
  children?: any
}

const HootsuiteStreamLayout = ({ children }: TApplicationLayoutProps) => {
  const [layout, setLayout] = useState<ELayoutTypes>(ELayoutTypes.public)
  const oidc = useSelector((state: TDefaultSagas) => state.oidc)
  const location = useLocation()

  // Layout Rendering
  const getLayout = (pathname: string): ELayoutTypes => {
    if (/^\/authentication(?=\/|$)/i.test(pathname)) {
      return ELayoutTypes.auth
    }

    if (pathname === '/') {
      return ELayoutTypes.public
    }

    return ELayoutTypes.app
  }

  useEffect(() => {
    setLayout(getLayout(location.pathname))
  }, [location])

  const BootstrappedLayout = () => {
    const { pathname } = location
    const isAuthCallback = () => /^\/authentication\/callback/i.test(pathname)
    const loggedOut = () => /^\/logout_successful/i.test(pathname)

    if (isAuthCallback()) {
      return <CallbackPage.routeProps.component />
    }

    if (loggedOut()) {
      return <Logout.routeProps.component />
    }

    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (oidc?.isLoadingUser === true) {
      return <Loader />
    }

    const isAuthLayout = layout === 'auth'

    // redirect to login page if current is not login page and user not authorized
    if (!isAuthLayout && !oidc?.user) {
      return <Redirect to="/authentication/login" />
    }

    const Container = Layouts[layout]

    // in other case render previously set layout
    return <Container>{children}</Container>
  }

  return (
    <>
      <Helmet title="Admin Panel" titleTemplate="Accalli/o | %s" />
      {BootstrappedLayout()}
    </>
  )
}

export default HootsuiteStreamLayout
